// extracted by mini-css-extract-plugin
export default {"backWrapper":"BackButton_backWrapper__Dmx8e","backButton":"BackButton_backButton__LbcF2"};